// extracted by mini-css-extract-plugin
export default {"NotFound_container":"NotFound_NotFound_container__-w5V4"};